import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "d-inline ms-2" };
const _hoisted_2 = { class: "modal-title w-100 text-center fw-bold fs-4 mb-4" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "d-flex align-items-center justify-content-center mb-5" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "ms-2" };
const _hoisted_7 = ["id"];
const _hoisted_8 = { class: "fw-bold" };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = { class: "fw-bold" };
const _hoisted_11 = { class: "m-0" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = {
    class: "position-relative w-100 text-center border-start-3 border-top-0 border-secondary d-flex align-items-center justify-content-center rounded-bottom p-4 py-5",
    style: { "cursor": "pointer", "border-style": "dashed !important" }
};
const _hoisted_14 = { class: "fw-bold text-primary mb-0" };
const _hoisted_15 = {
    key: 0,
    class: "w-50 d-flex align-items-center justify-content-center"
};
const _hoisted_16 = {
    key: 0,
    class: "fw-bold border-bottom mb-3 pb-2"
};
const _hoisted_17 = { class: "row row-cols-4 g-4" };
const _hoisted_18 = { class: "col" };
const _hoisted_19 = { class: "bg-light rounded border position-relative" };
const _hoisted_20 = ["src"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = { key: 1 };
const _hoisted_23 = { class: "bg-primary d-flex align-items-center justify-content-center flex-column rounded-3 p-5" };
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { class: "bg-danger d-flex align-items-center justify-content-center rounded-3 p-3" };
const _hoisted_27 = { class: "fs-5 fw-bold text-white text-center" };
import { onMounted, ref, watch } from 'vue';
import axios from 'axios';
import { Canvas, Control, FabricImage, loadSVGFromURL, util } from 'fabric';
import Swal from 'sweetalert2';
import { loadConfigs, loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import DesignElementManager from './DesignElementManager.vue';
import AiImageManager from './AiImageManager.vue';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ImageManager',
    props: {
        configurationComponentId: String,
        maxImagesAmount: {
            type: Number,
            default: 3
        },
        initialCanvas: Canvas,
        allowedPrintModes: {
            type: Array,
            default: [1, 2, 3] //1=silkscreen, 2=digital, 3=gravure
        },
    },
    emits: ['update', 'usedColors'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const emit = __emit;
        const instanceId = Math.random().toString(36).substring(2, 7);
        const validImageTypes = ref(['image/jpeg', 'image/png', 'image/gif', 'image/bmp']);
        const validVectorTypes = ref(['image/svg+xml', 'application/postscript', 'application/pdf', 'application/illustrator']);
        const maxFileSize = ref(10240000);
        const minDpi = ref(300);
        const allowImageBelowDpi = ref(true); //TODO: Where is the control for this?
        const contactEmail = ref('');
        const loading = ref(false);
        const error = ref(null);
        const fileInput = ref(null);
        const images = ref([]);
        const requiresDigitalPrintMode = ref(false);
        const deleteImg = new Image();
        deleteImg.src = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
        const centerImg = new Image();
        centerImg.src = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http://www.w3.org/2000/svg%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22currentColor%22%20class%3D%22bi%20bi-align-center%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cpath%20d%3D%22M8%201a.5.5%200%200%201%20.5.5V6h-1V1.5A.5.5%200%200%201%208%201m0%2014a.5.5%200%200%201-.5-.5V10h1v4.5a.5.5%200%200%201-.5.5M2%207a1%201%200%200%201%201-1h10a1%201%200%200%201%201%201v2a1%201%200%200%201-1%201H3a1%201%200%200%201-1-1z%22/%3E%3C/svg%3E";
        const modal = ref();
        const allowTemplates = ref(false);
        const allowAiImages = ref(false);
        onMounted(async () => {
            if (props.initialCanvas) {
                props.initialCanvas.getObjects('image').forEach((obj) => {
                    if (obj.get('isFullDesign') !== true) {
                        registerDeleteControl(obj);
                        registerCenterObjectControl(obj);
                    }
                    images.value.push(obj);
                });
                props.initialCanvas.getObjects('group', 'path').forEach((obj) => {
                    if (obj.get('isFullDesign') !== true) {
                        registerDeleteControl(obj);
                        registerCenterObjectControl(obj);
                    }
                    images.value.push(obj);
                });
            }
            validImageTypes.value = await loadConfigs('images.image_mime_types');
            validVectorTypes.value = await loadConfigs('images.vector_mime_types');
            maxFileSize.value = (await loadTenantConfigs('max_image_upload_size')) * 1000;
            minDpi.value = await loadTenantConfigs('min_dpi');
            contactEmail.value = await loadTenantConfigs('mail_contact');
            allowTemplates.value = await loadTenantConfigs('configurator_allow_templates');
            allowAiImages.value = await loadTenantConfigs('configurator_allow_ai_images');
        });
        watch(() => images.value.length, () => {
            emit('update', images.value, 'image');
            countColors();
        }, { deep: true });
        async function uploadImage() {
            if (props.maxImagesAmount != 0 && images.value.length >= props.maxImagesAmount) {
                showError(t('Maximale Anzahl an Grafiken/Bildern erreicht'));
                return;
            }
            const file = fileInput.value?.files?.[0];
            if (file) {
                loading.value = true;
                try {
                    checkAllowedFileTypes(file);
                    checkImageSize(file);
                    //Check DPI only for images on server side
                    // checkImageDPI(file)
                    //     .catch((error) => {
                    //         throw new Error(error);
                    //     });
                }
                catch (error) {
                    if (error instanceof Error) {
                        console.error(error.message);
                        showError(error.message);
                    }
                    else {
                        console.error(error);
                    }
                    loading.value = false;
                    return;
                }
                const formData = new FormData();
                formData.append('image', file);
                formData.append('allowImageBelowDpi', allowImageBelowDpi.value.toString());
                axios.post(route('configurator.printConfiguration.images.store', props.configurationComponentId), formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(function (response) {
                    if (response.data.belowMinDPI) {
                        Swal.fire({
                            title: t('Mindestauflösung unterschritten!'),
                            html: t('Leider liegen die DPI der hochgeladenen Daten unter dem für ein optimales Druckergebnis erforderlichen Minimum. Benötigen Sie Hilfe bei der Erstellung Ihrer Druckdaten?<br /><br />Kein Problem!<br /><br />Sie können einfach mit den vorhandenen Daten weitermachen und mit den vorhandenen Daten ein individuelles Angebot oder eine Kontaktaufnahme anfragen.'),
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: t("Weitermachen"),
                            cancelButtonText: t("Bild löschen"),
                            confirmButtonColor: "#528399",
                            cancelButtonColor: "#dc3545",
                        }).then((result) => {
                            if (!result.isConfirmed) {
                                removeImage(response.data.id);
                            }
                            else {
                                createImage(response.data);
                            }
                        });
                    }
                    else {
                        createImage(response.data);
                    }
                    fileInput.value = null;
                    loading.value = false;
                })
                    .catch(function (error) {
                    console.log(error);
                    loading.value = false;
                    showError(error);
                });
            }
        }
        function checkAllowedFileTypes(file) {
            if (!props.allowedPrintModes.includes(2)) {
                if (!validVectorTypes.value.includes(file.type)) {
                    throw new Error(t('Bei dieser Konfiguration sind leider NUR Vektorgrafiken (.svg, .pdf, etc.) erlaubt.'));
                }
            }
            if (!validImageTypes.value.includes(file.type) && !validVectorTypes.value.includes(file.type)) {
                throw new Error(t('Dateityp ist nicht erlaubt'));
            }
        }
        function checkImageSize(file) {
            if (file) {
                if (file.size > maxFileSize.value) {
                    throw new Error(t('Datei ist zu groß. Max. Dateigröße:') + ' ' + (maxFileSize.value / 1000) + ' KB');
                }
            }
        }
        function checkImageDPI(file) {
            return new Promise((resolve, reject) => {
                if (validVectorTypes.value.includes(file.type)) {
                    // console.log(`Skipping DPI check for vector file: ${file.name}`);
                    return resolve(void 0);
                }
                if (!validImageTypes.value.includes(file.type)) {
                    return reject(t('Dateityp ist nicht erlaubt'));
                }
                const img = new Image();
                const reader = new FileReader();
                reader.onload = (e) => {
                    img.onload = () => {
                        const widthInPixels = img.naturalWidth;
                        const heightInPixels = img.naturalHeight;
                        const widthInInches = 8;
                        const dpiX = widthInPixels / widthInInches;
                        const dpiY = heightInPixels / widthInInches;
                        // console.log(`DPI X: ${dpiX}, DPI Y: ${dpiY}`);
                        if (dpiX >= minDpi.value && dpiY >= minDpi.value) {
                            resolve(true);
                        }
                        else {
                            reject(t('Bild liegt unter den min. DPI') + ' (' + minDpi.value + ')');
                        }
                    };
                    img.onerror = () => reject(trans('Fehler beim Upload. Bitte laden Sie Ihre Datei erneut hoch. Bitte kontaktieren Sie uns unter {mail} wenn das Problem erneut auftritt.', { mail: contactEmail.value }));
                    if (e.target && e.target.result) {
                        img.src = e.target.result;
                    }
                    else {
                        reject('Error loading image.');
                    }
                };
                reader.onerror = () => reject(t('Datei konnte nicht gelesen werden. Bitte erneut versuchen.'));
                reader.readAsDataURL(file);
            });
        }
        function createImage(details) {
            const setImageProperties = (obj) => {
                obj = defineImageStartSize(obj);
                obj.set({
                    left: props.initialCanvas ? (props.initialCanvas.width - obj.width * obj.scaleX) / 2 : 0,
                    top: props.initialCanvas ? (props.initialCanvas.height - obj.height * obj.scaleY) / 2 : 0,
                    borderColor: '#528399',
                    cornerColor: '#528399',
                    cornerSize: 10,
                    transparentCorners: false,
                    borderDashArray: [4, 4],
                    cornerStyle: 'circle'
                });
                obj.set('id', details.id);
                obj.set('url', details.url);
                obj.set('colors', details.colors);
                obj.set('requiredPrintMode', details.requiredPrintMode);
                obj.set('belowMinDPI', details.belowMinDPI); //TODO: if belowMinDPI only requests and no orders are possible
                images.value.push(obj);
            };
            setTimeout(() => {
                if (details.fileType == 'svg') {
                    loadSVGFromURL(details.url).then(({ objects }) => {
                        const obj = util.groupSVGElements(objects.filter((o) => o !== null));
                        setImageProperties(obj);
                        registerDeleteControl(obj);
                        registerCenterObjectControl(obj);
                    });
                }
                else {
                    FabricImage.fromURL(details.url).then((obj) => {
                        setImageProperties(obj);
                        registerDeleteControl(obj);
                        registerCenterObjectControl(obj);
                    }).catch((error) => {
                        console.error('Error loading image:', error);
                    });
                }
            }, 200);
        }
        function registerDeleteControl(obj) {
            if (obj.get('editingBlocked') == true) {
                return;
            }
            obj.controls.deleteControl = new Control({
                x: 0.65,
                y: -0.55,
                offsetY: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: (_eventData, transform) => {
                    removeImage(transform.target.get('id'));
                },
                render: (ctx, left, top, _styleOverride, fabricObject) => {
                    const size = 28;
                    ctx.save();
                    ctx.translate(left, top);
                    ctx.rotate(util.degreesToRadians(fabricObject.angle));
                    ctx.drawImage(deleteImg, -size / 2, -size / 2, size, size);
                    ctx.restore();
                }
            });
        }
        function registerCenterObjectControl(obj) {
            if (obj.get('editingBlocked') == true) {
                return;
            }
            obj.controls.centerControl = new Control({
                x: 0.65,
                y: -0.25,
                offsetY: 16,
                cursorStyle: 'pointer',
                mouseUpHandler: (_eventData, transform) => {
                    centerObjectInCanvas(transform.target);
                },
                render: (ctx, left, top, _styleOverride, fabricObject) => {
                    const size = 28;
                    ctx.save();
                    ctx.translate(left, top);
                    ctx.rotate(util.degreesToRadians(fabricObject.angle));
                    ctx.drawImage(centerImg, -size / 2, -size / 2, size, size);
                    ctx.restore();
                }
            });
        }
        function defineImageStartSize(object) {
            let finished = false;
            while (!finished) {
                if (props.initialCanvas && ((object.height * object.scaleX) > props.initialCanvas.height || (object.width * object.scaleX) > props.initialCanvas.width)) {
                    object.scaleX *= 0.5;
                    object.scaleY *= 0.5;
                }
                else {
                    finished = true;
                }
            }
            return object;
        }
        function removeImage(imageUuid) {
            try {
                loading.value = true;
                axios.delete(route('configurator.printConfiguration.images.destroy', imageUuid))
                    .then(function (response) {
                    const index = images.value.findIndex(image => image.get('id') === imageUuid);
                    if (index !== -1) {
                        images.value.splice(index, 1);
                    }
                    loading.value = false;
                })
                    .catch(function (error) {
                    console.log(error);
                    loading.value = false;
                });
            }
            catch (error) {
                console.error(error);
                loading.value = false;
            }
        }
        function countColors() {
            let usedColors = [];
            requiresDigitalPrintMode.value = false;
            images.value.forEach((image) => {
                // console.log('requiredPrintMode', image.get('requiredPrintMode'))
                if (image.get('colors')) {
                    usedColors = [...new Set([...usedColors, ...image.get('colors')])];
                }
                requiresDigitalPrintMode.value = image.get('requiredPrintMode') == 'digital';
            });
            emit('usedColors', usedColors, requiresDigitalPrintMode.value);
        }
        function showError(text) {
            error.value = text;
            setTimeout(() => {
                error.value = null;
            }, 3000);
        }
        function updateDesignElements(objects) {
            objects.forEach((obj) => {
                if (images.value.findIndex(image => image.get('id') === obj.get('id')) !== -1) {
                    return;
                }
                images.value.push(obj);
            });
            //filter images. Remove images with "designElement" property true, which are not in objects array
            images.value = images.value.filter((image) => {
                if (image.get('designElement') == true) {
                    return objects.findIndex(obj => obj.get('id') === image.get('id')) !== -1;
                }
                return true;
            });
        }
        function centerObjectInCanvas(obj) {
            if (props.initialCanvas) {
                obj.set({
                    left: (props.initialCanvas.width - obj.width * obj.scaleX) / 2,
                    top: (props.initialCanvas.height - obj.height * obj.scaleY) / 2,
                });
                emit('update', images.value, 'image');
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: "btn btn-primary d-inline-flex align-items-center m-2",
                    onClick: _cache[0] || (_cache[0] = ($event) => (modal.value.open($event)))
                }, [
                    _cache[1] || (_cache[1] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-file-earmark-image",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", { d: "M6.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" }),
                        _createElementVNode("path", { d: "M14 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zM4 1a1 1 0 0 0-1 1v10l2.224-2.224a.5.5 0 0 1 .61-.075L8 11l2.157-3.02a.5.5 0 0 1 .76-.063L13 10V4.5h-2A1.5 1.5 0 0 1 9.5 3V1z" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('Grafiken')), 1)
                ]),
                (allowTemplates.value)
                    ? (_openBlock(), _createBlock(DesignElementManager, {
                        key: 0,
                        configurationComponentId: __props.configurationComponentId,
                        initialCanvas: __props.initialCanvas,
                        initialImages: images.value,
                        onUpdate: updateDesignElements
                    }, null, 8, ["configurationComponentId", "initialCanvas", "initialImages"]))
                    : _createCommentVNode("", true),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    id: 'configurationImages' + _unref(instanceId),
                    closeButton: _unref(t)('weiter'),
                    zIndex: 1050,
                    size: 'md'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('Grafiken/Bilder')), 1),
                        (!loading.value && error.value == null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass({ 'w-50': allowAiImages.value, 'w-100': !allowAiImages.value })
                                    }, [
                                        _createElementVNode("button", {
                                            class: "w-100 btn btn-sm btn-secondary d-inline-flex align-items-center justify-content-center rounded",
                                            "data-bs-toggle": "collapse",
                                            href: '#configurationImagesInfos' + _unref(instanceId)
                                        }, [
                                            _cache[2] || (_cache[2] = _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-info-circle",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                _createElementVNode("path", { d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" })
                                            ], -1)),
                                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('Infos')), 1)
                                        ], 8, _hoisted_5),
                                        _createElementVNode("div", {
                                            class: "collapse p-2 bg-light rounded mb-3",
                                            id: 'configurationImagesInfos' + _unref(instanceId)
                                        }, [
                                            _createElementVNode("h5", _hoisted_8, _toDisplayString(_unref(t)('Siebdruck')), 1),
                                            _createElementVNode("p", {
                                                innerHTML: _unref(trans)('Es können maximal {colors} Farben verwendet werden.<br />Sie können .svg-, .pdf-, .eps- und .ai-Dateien mit bis zu {colors} Farben oder .jpg und .png-Dateien wählen.', { colors: 4 })
                                            }, null, 8, _hoisted_9),
                                            _createElementVNode("h5", _hoisted_10, _toDisplayString(_unref(t)('Digitaldruck')), 1),
                                            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('Es gelten die gleichen Dateitypen, wie für Siebdruck. Die Anzahl der Farben ist nicht begrenzt.')), 1)
                                        ], 8, _hoisted_7),
                                        _createElementVNode("div", null, [
                                            (props.maxImagesAmount != 0 && images.value.length < props.maxImagesAmount)
                                                ? (_openBlock(), _createElementBlock("form", _hoisted_12, [
                                                    _createElementVNode("label", _hoisted_13, [
                                                        _createElementVNode("input", {
                                                            type: "file",
                                                            ref_key: "fileInput",
                                                            ref: fileInput,
                                                            onChange: uploadImage,
                                                            class: "position-absolute w-100 h-100",
                                                            style: { "opacity": "0" }
                                                        }, null, 544),
                                                        _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('Klicken oder Elemente hineinziehen')), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 2),
                                    (allowAiImages.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createVNode(AiImageManager, {
                                                onSelectImage: createImage,
                                                configurationComponentId: __props.configurationComponentId,
                                                modalTargetOnClose: 'configurationImages' + _unref(instanceId)
                                            }, null, 8, ["configurationComponentId", "modalTargetOnClose"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                (images.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("h6", _hoisted_16, _toDisplayString(_unref(t)('Hochgeladene Grafiken/Bilder')), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_17, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("img", {
                                                    src: image.get('url'),
                                                    class: "w-100 p-1"
                                                }, null, 8, _hoisted_20),
                                                (image.get('editingBlocked') == null || image.get('editingBlocked') == false)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "btn position-absolute top-0 start-100 translate-middle",
                                                        onClick: ($event) => (removeImage(image.get('id')))
                                                    }, [...(_cache[3] || (_cache[3] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                height: "24",
                                                                fill: "currentColor",
                                                                class: "bi bi-x-circle-fill text-danger",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" })
                                                            ], -1)
                                                        ]))], 8, _hoisted_21))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", {
                                        class: "spinner-grow text-white mb-4",
                                        role: "status"
                                    }, [
                                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                    ], -1)),
                                    _createElementVNode("span", {
                                        class: "fs-5 fw-bold text-white text-center",
                                        innerHTML: _unref(trans)('Bitte warten!<br />Ihre Grafiken/Bilder werden verarbeitet')
                                    }, null, 8, _hoisted_24)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_Transition, null, {
                            default: _withCtx(() => [
                                (error.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("span", _hoisted_27, _toDisplayString(error.value), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["id", "closeButton"])
            ], 64));
        };
    }
});
